import { useEffect, useMemo } from "react";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import BootstrapTable from "react-bootstrap-table-next";
import paginationFactory, { PaginationProvider }  from "react-bootstrap-table2-paginator";
import { getAuthorities } from "../../../../../../_helpers/Helpers";
import * as actions from "../../../_redux/user-groups/UserGroupsAction";
import * as uiHelpers from "../UserGroupsUIHelpers";
import { 
  getSelectRow, 
  getHandlerTableChange,  
  NoRecordsFoundMessage, 
  PleaseWaitMessage, 
  sortCaret
} from "../../../../../../_metronic/_helpers";
import * as columnFormatters from "./column-formatters";
import { Pagination } from "../../../../../../_metronic/_partials/controls";
import { useUserGroupsUIContext } from "../UserGroupsUIContext";

export function UserGroupsTable({ 
  deleteUserGroups 
}) {
  // User Groups UI Context
  const userGroupsUIContext = useUserGroupsUIContext();
  const userGroupsUIProps = useMemo(() => {
    return {
      ids: userGroupsUIContext.ids,
      setIds: userGroupsUIContext.setIds,
      queryParams: userGroupsUIContext.queryParams,
      setQueryParams: userGroupsUIContext.setQueryParams,
      openEditUserGroupPage: userGroupsUIContext.openEditUserGroupPage
    };
  }, [userGroupsUIContext]);

  // Getting curret state of User Groups list from store (Redux)
  const { currentState } = useSelector(
    (state) => ({ currentState: state.userGroups }),
    shallowEqual
  );
  const { totalCount, entities, authorities, listLoading } = currentState;
  
  // Authority Parameters
  const { isEditionAuthorized, isDeletionAuthorized } = getAuthorities(authorities);
  
  // User Groups Redux state
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(actions.getUserGroups(userGroupsUIProps.queryParams));
    return () => dispatch(actions.cleanUserGroupsState());
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [userGroupsUIProps.queryParams, dispatch]);

  // Table columns
  const columns = [
    {
      dataField: "name",
      text: "Adı",
      sort: true,
      sortCaret: sortCaret,
    },
    {
      dataField: "definition",
      text: "Açıklaması",
      sort: true,
      sortCaret: sortCaret,
    }
  ];

  const actionColumn = {
    dataField: "action",
    text: "İşlemler",
    formatter: columnFormatters.ActionsColumnFormatter,
    formatExtraData: {
      isEditionAuthorized,
      isDeletionAuthorized,
      openEditUserGroupPage: userGroupsUIProps.openEditUserGroupPage,
      deleteUserGroups
    },
    classes: "text-right pr-0",
    headerClasses: "text-right pr-3",
    style: {
      minWidth: "100px",
    }
  }

  if (isEditionAuthorized || isDeletionAuthorized) columns.push(actionColumn);

  // Table pagination properties
  const paginationOptions = {
    custom: true,
    totalSize: totalCount,
    sizePerPageList: uiHelpers.sizePerPageList,
    sizePerPage: userGroupsUIProps.queryParams.pageSize,
    page: userGroupsUIProps.queryParams.pageNumber
  };
  
  return (
    <PaginationProvider pagination={paginationFactory(paginationOptions)}>
      {({ paginationProps, paginationTableProps }) => {
        return (
          <Pagination
            isLoading={listLoading}
            paginationProps={paginationProps}
          >
            <BootstrapTable
              wrapperClasses="table-responsive"
              classes="table table-head-custom table-vertical-center overflow-hidden"
              bootstrap4
              bordered={false}
              remote
              keyField="id"
              data={entities ?? []}
              columns={columns}
              defaultSorted={uiHelpers.defaultSorted}
              onTableChange={getHandlerTableChange(
                userGroupsUIProps.setQueryParams
              )}
              selectRow={getSelectRow({
                entities,
                ids: userGroupsUIProps.ids,
                setIds: userGroupsUIProps.setIds,
                hidden: !isDeletionAuthorized
              })}
              {...paginationTableProps}
            >
              <PleaseWaitMessage entities={entities} />
              <NoRecordsFoundMessage entities={entities} />
            </BootstrapTable>
          </Pagination>
        );    
      }}
    </PaginationProvider>  
  );
}